import { DateFormat1 } from "components/common/formatter";

function groupKeyForRow(row) {
    return `${DateFormat1(row?.date || "")}__${(row?.reference || "").trim()}`;
}

export function buildGroupedDisplayRows(rows, expandedGroups, selectedState) {
    if (!Array.isArray(rows)) return [];
    const groups = new Map();
    rows.forEach((row) => {
        const key = groupKeyForRow(row);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
    });

    const composed = [];
    groups.forEach((children, key) => {
        if (children.length <= 1) {
            composed.push(children[0]);
            return;
        }
        const total = children.reduce((sum, c) => sum + (Number(c.netAmount) || 0), 0);
        const allSamePeriod = children.every(
            (c) => c.transactionPeriod === children[0].transactionPeriod,
        );
        const allSelected = children.every((c) => !!selectedState[c.postingId]);
        const someSelected = children.some((c) => !!selectedState[c.postingId]);

        composed.push({
            postingId: `group-${key}`,
            isGroupParent: true,
            expanded: !!expandedGroups[key],
            groupKey: key,
            date: children[0].date,
            reference: children[0].reference,
            details: "",
            postingType: children[0].postingType,
            matterRef: "",
            matterID: null,
            transactionPeriod: allSamePeriod ? children[0].transactionPeriod : "",
            netAmount: total,
            groupChildren: children,
            groupAllSelected: allSelected,
            groupSomeSelected: someSelected,
        });
    });
    return composed;
}
